import { studioTimeZone } from "./studioTime";

export function consentDateLabel(value, locale, form = {}, studio = {}) {
  if (!value) return "";
  // Backend legacy instants without an offset are UTC, never device-local.
  const raw = String(value);
  const instant = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(raw) ? `${raw}Z` : value;
  const parsed = new Date(instant);
  if (Number.isNaN(parsed.getTime())) return "";
  const timeZone = form.document_timezone
    ? studioTimeZone({ timezone: form.document_timezone })
    : studioTimeZone(studio);
  return parsed.toLocaleString(locale, {
    dateStyle: "medium", timeStyle: "short", timeZone,
  });
}
